export default "__VITE_ASSET__C9luBYeY__"